// Gemeinsame Teile für Rundgang und Zähler-Kontrolle (design_handoff_uebergabe §4.2/§4.3):
// Symbole je Raum/Zählerart, Foto-Kachel (Kamera/Bilder), Foto-Vorschau, Touch-Erkennung.
import type { ReactNode } from 'react';
import {
  Archive, Baby, Bathtub, Bed, Camera, CookingPot, Couch, DoorOpen, Drop, Flame, Garage, Gauge, House, Lightning, SquaresFour,
  Stairs, Sun, Thermometer, Toilet, type Icon,
} from '@phosphor-icons/react';
import type { RaumSymbol, ZaehlerSymbol } from '../../../../lib/uebergabeAnsicht/darstellung';

export const RAUM_ICON: Record<RaumSymbol, Icon> = {
  flur: DoorOpen, wohnen: Couch, kueche: CookingPot, bad: Bathtub, wc: Toilet, schlafen: Bed, kind: Baby,
  balkon: Sun, keller: Stairs, abstell: Archive, dach: House, garage: Garage, sonstig: SquaresFour,
};

export const ZAEHLER_ICON: Record<ZaehlerSymbol, Icon> = {
  strom: Lightning, kaltwasser: Drop, warmwasser: Drop, waerme: Thermometer, gas: Flame, sonstig: Gauge,
};

/** Auf Touch-Geräten (Tablet/Handy vor Ort) Tippflächen auf 44 px heben (Handoff §6). */
export const istTouch = (): boolean => typeof window !== 'undefined' && !!window.matchMedia?.('(pointer: coarse)').matches;

/** Weißer Text auf hellem Gelb ist unlesbar — dort dunkle Schrift. */
export const schriftAuf = (farbe: string): string => (farbe === '#ffcc00' ? '#3a2a00' : '#fff');

/** Kachel „Foto“: öffnet Kamera bzw. Bildauswahl (capture=environment wie bisher). */
export function FotoKachel({ mehrere = true, tip, onDateien, groesse = 72, label = 'Foto' }: {
  mehrere?: boolean; tip: string; onDateien: (dateien: FileList) => void; groesse?: number; label?: string;
}) {
  return (
    <label data-tip={tip} className="inline-flex shrink-0 cursor-pointer flex-col items-center justify-center"
      style={{ width: groesse, height: groesse, gap: 3, borderRadius: 16, border: '1.5px dashed var(--line)', background: 'var(--fill)', color: 'var(--ink2)', fontSize: 11.5, fontWeight: 800 }}>
      <Camera size={20} weight="fill" color="var(--acc)" />
      {label}
      <input type="file" accept="image/*" capture="environment" multiple={mehrere} className="hidden" aria-label={tip.split(' – ')[0]}
        onChange={(e) => { if (e.target.files?.length) onDateien(e.target.files); e.target.value = ''; }} />
    </label>
  );
}

/** Zeile mit Fotos und Foto-Kachel. */
export function FotoReihe({ children }: { children: ReactNode }) {
  return <div className="flex flex-wrap items-center" style={{ gap: 8 }}>{children}</div>;
}
